import React from "react";
import "./ServicesHero.css";

/**
 * Image lives in /public
 * Using PUBLIC_URL ensures it works in dev + production builds.
 */
const BG_URL = `${process.env.PUBLIC_URL}/mng-owner.jpg`;

export default function ServicesHero() {
  return (
    <section
      className="srv-hero"
      /* custom CSS variable consumed by ServicesHero.css */
      style={{ "--hero-bg": `url(${BG_URL})` }}
      aria-label="Page hero for Services"
    >
      <div className="srv-hero__inner">
        <h1 className="srv-hero__title">Our projects</h1>
      </div>
    </section>
  );
}
